import React, { forwardRef, useImperativeHandle } from 'react';
import { EditorContent, useCurrentEditor } from '@tiptap/react';

import LinkBubbleMenu from './MenuBar/link/LinkBubbleMenu';
import { LinkModal } from './MenuBar/link/LinkModal';

export interface PartialEditor {
  getHTML: () => string | null;
}

const EditorContentComponent = forwardRef<PartialEditor>((_, ref) => {
  const { editor } = useCurrentEditor();

  // Expose a function to the parent component
  useImperativeHandle(ref, () => ({
    getHTML() {
      return editor ? editor.getHTML() : null;
    },
  }));

  return (
    <>
      <EditorContent editor={editor} />
      <LinkModal />
      <LinkBubbleMenu />
    </>
  );
});

EditorContentComponent.displayName = 'EditorContentComponent';

export default EditorContentComponent;
